export const getTodoListItemNode = options => {
  return {
    attrs: {
      done: {
        default: false
      }
    },
    content: "paragraph",
    defining: true,
    toDOM(node) {
      const {
        done
      } = node.attrs;
      const {
        renderAsHtml,
        enableOnReadOnlyMode
      } = options;
      const checkboxProps = {
        type: 'checkbox',
        class: 'todo-checkbox'
      };
      if (done) {
        checkboxProps.checked = true;
      }
      if (renderAsHtml && enableOnReadOnlyMode) {
        checkboxProps.disabled = true;
      }
      return ['li', {
        class: 'todo-list-item',
        'data-type': 'todo_item',
        'data-done': done.toString()
      }, ['input', checkboxProps], ['span', {
        class: 'todo-list-content'
      }, 0]];
    },
    parseDOM: [{
      // priority: 51, // Needs higher priority than other nodes that use a "li" tag
      tag: '[data-type="todo_item"]',
      getAttrs(dom) {
        return {
          done: dom.getAttribute('data-done') === 'true'
        };
      }
    }]
  };
};